// Returns number of days based on given value
export const getTimeRangeValue = (period) => {
  switch (period) {
    case '1 day':
      return '24 hrs';
    case '1 week':
      return 7;
    case '1 month':
      return 30;
    case '3 month':
      return 90;
    default:
      break;
  }
};
